export default {
    data() {
        // var checkAge = (rule, value, callback) => {
        //     if (!value) {
        //         return callback(new Error('年龄不能为空'));
        //     }
        //     setTimeout(() => {
        //         if (!Number.isInteger(value)) {
        //             callback(new Error('请输入数字值'));
        //         } else {
        //             if (value < 18) {
        //                 callback(new Error('必须年满18岁'));
        //             } else {
        //                 callback();
        //             }
        //         }
        //     }, 1000);
        // };
        // var validatePass = (rule, value, callback) => {
        //     if (value === '') {
        //         callback(new Error('请输入密码'));
        //     } else {
        //         if (this.ruleForm.checkPass !== '') {
        //             this.$refs.ruleForm.validateField('checkPass');
        //         }
        //         callback();
        //     }
        // };
        // var validatePass2 = (rule, value, callback) => {
        //     if (value === '') {
        //         callback(new Error('请再次输入密码'));
        //     } else if (value !== this.ruleForm.pass) {
        //         callback(new Error('两次输入密码不一致!'));
        //     } else {
        //         callback();
        //     }
        // };
        return {
            // 学员列表的数据 
            tableData: [],
            // 另一个存放学生数据
            tableDataNum: [],
            // 对应的班级得到的课程
            newData: [],
            // 存放搜索的数组
            searchData: [],
            // 班级学生的数据
            gridData: [{
                date: '2016-05-02',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-04',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }],
            //存储学员的数据 
            stuData: [],
            // 存储课程数量
            courseNum: [],
            // // 已完成的人数
            // CompletionP: 0,
            // // 未完成的人数 
            // inCompletionP: 0,
            // // 学生完成情况的完成率
            // CompletionRate: 0,
            // 计算分数
            scoress: 0,
            scoress1: 0,

            // 已完成评价 
            commonSucc: 0,
            // 未完成评价
            inCommonSucc: 0,
            // 未开始评论的人数 
            noCommon: 0,
            // 完成率的计算
            overP: 0,
            //添加公告弹出
            noticeDialog: false,

            dialogTableVisible: false,
            // 弹框的出现与否
            dialogFormVisible: false,
            // form 是表单存储数据的对象   多个搜索直接进去就可以的了
            // form: {
            //     user_name: '',
            //     label_name: '',
            //     parent_label_name: '',
            //     idcard: '',
            //     company: '',
            //     score: '',
            //     class_name: '',
            //     token: this.$store.state.instructor,
            //     offset: 0,
            //     length: 999
            // },
            // 设置的弹窗宽度
            formLabelWidth: '120px',
            // 点击按钮显示另一个视图的班级列表
            showOtherList: true,
            // 点击查看学员的变化 
            showOtherList2: false,
            // 点击评论状态栏的变化
            evaluate: false,
            sizeForm: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: '',
            },
            // ruleForm: {
            //     pass: '',
            //     checkPass: '',
            //     age: ''
            // },
            password: '',
            repassword: '',
            // rules: {
            //     pass: [
            //         { validator: validatePass, trigger: 'blur' }
            //     ],
            //     checkPass: [
            //         { validator: validatePass2, trigger: 'blur' }
            //     ],
            //     age: [
            //         { validator: checkAge, trigger: 'blur' }
            //     ]
            // },
            // 辅导员对象
            instructorObj: {},
            // 辅导员id
            instructor_id: '',
            // 班级评分状况百分比
            percentageArray: [],
            // 总条数
            total: 0,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 15,
            length: 0,
            num: 0,
            // 学生总数
            studentNum: 0,
            // 已完成学习的学生总数
            goodStudentNum: 0,
            // 未完成学习的学生总数
            badStudnetNum: 0,

            // 搜索数据
            login_name: '',
            phone: '',
            user_name: '',
            idcard: '',
            company: '',
            class_name: '',
            label_name: '',
            parent_label_name: '',

            // 辅导员所管理的班级id数组
            class_id_arr: [],
            textareaContent: '',
            //上传文件
            action: this.baseUrl + 'file/upload_class?token=' + this.$store.state.instructor,
            fileList: [],
            fileName: '',
            realName: '',
            id: '',
            showOtherList3: false,
            showOtherList4: false,
            // 提问答疑数据
            question_answer: [],
            classId: '',
            commendVisible: false,
            // 提问答疑列表
            commendList: [],
            replyVisible: false,
            replyText: '',
            // 问题ID
            question_id: '',
            instructorCommend: [],
            //主题讨论数据
            noticeContent: [],
            noticedialogVisible: false,
            // 课程id
            productID: '',
            // 主题讨论列表
            noticeList: [],
            // 主题讨论弹出框
            noticereplyVisible: false,
            notivecommendVisible: false,
            // 主题讨论评论列表
            noticeList1: [],
            noticeList2: [],
            // 班级名称
            className: '',

            // 辅导员主题讨论发帖数
            discussNum: 0,
            // 辅导员发布公告简报数量
            bulletinNum: 0,
            // 辅导员答疑数量
            answeringNum: 0,
            // 当前点击的班级id
            currClassId: 0,
            // 控制点击学习督促按钮后显示学员列表的变量
            dialogStudentsVisible: false,
            // 学员列表
            studentList: [],
            // 学员总数
            studentTotal: 0,
            // 学员列表当前页
            studentCurrPage: 1,
            // 学员id列表
            idArr: [],
            // 控制点击发送站内信按钮后显示输入站内信内容区域的变量
            dialogMessageVisible: false,
            // 站内信内容
            message: ''
        }
    },
    props: {
        // 辅导员ID
        instructor_id1: {
            type: Number,
        }
    },
    methods: {
        httpreq(q) {
            this.$upload(this.action, q).then(res => {
                this.realName = res.data.result
                this.file_as_name = res.data.result
                this.noticeDialog = false
            })
        },
        noticeDialogFun(item) {
            // console.log(item)
            this.noticeDialog = true
            this.id = item.class_id
            this.className = item.class_name
        },
        confirmUploadFile() {
            // 发送公告时判断简报和附件的内容是否为空，依次调用相应接口，内容空不调用接口
            // 接口class_bulletin/create为简报的接口
            // 接口class_file/create为附件的接口
            if (this.textareaContent !== '' && this.fileName !== '') {
                this.$post('class_bulletin/create', {
                    token: this.$store.state.instructor,
                    class_id: this.id,
                    bulletin: this.textareaContent
                }).then(res => {
                    if (res.data.status == 'success') {
                        this.$message({
                            showClose: true,
                            message: '简报上传成功',
                            type: 'success'
                        });
                        // // console.log('简报上传成功')
                    } else {
                        this.$message({
                            showClose: true,
                            message: '简报上传失败',
                            type: 'error'
                        });
                    }
                })
                this.$post('class_file/create', {
                    token: this.$store.state.instructor,
                    class_id: this.id,
                    file_name: this.realName,
                    file_as_name: this.fileName,
                }).then(res => {
                    if (res.data.status == 'success') {
                        this.$message({
                            showClose: true,
                            message: '附件上传成功',
                            type: 'success'
                        });
                        // // console.log('附件上传失败')
                    } else {
                        this.$message({
                            showClose: true,
                            message: '附件上传成功',
                            type: 'error'
                        });
                    }
                })


            } else if (this.textareaContent == '' && this.fileName !== '') {
                this.$post('class_file/create', {
                    token: this.$store.state.instructor,
                    class_id: this.id,
                    file_name: this.realName,
                    file_as_name: this.fileName
                }).then(res => {
                    if (res.data.status == 'success') {
                        this.$message({
                            showClose: true,
                            message: '附件上传成功',
                            type: 'success'
                        });
                        // // console.log('附件上传成功')
                    }
                })

            } else if (this.textareaContent !== '' && this.fileName == '') {
                this.$post('class_bulletin/create', {
                    token: this.$store.state.instructor,
                    class_id: this.id,
                    bulletin: this.textareaContent
                }).then(res => {
                    // // console.log(res)
                    if (res.data.status == 'success') {
                        this.$message({
                            showClose: true,
                            message: '简报上传成功',
                            type: 'success'
                        });
                        // // console.log('简报上传成功')
                    }
                })


            } else {
                this.$message.error('简报和附件不能都为空');
            }
        },
        // 上传成功后返回的值
        handleSuccess(response, file, fileList) {
            this.fileName = response.result
            this.realName = file.name
        },
        // 查看学员列表
        // 参数stuId 拿到的是班级的id 
        lookStu(stuId) {
            // console.log(stuId)
            this.showOtherList = false;
            this.showOtherList2 = true;
            this.showOtherList3 = false;
            this.showOtherList4 = false;
            this.evaluate = false
            var data = {
                class_id: stuId,
                offset: 0,
                length: 999,
                token: this.$store.state.instructor
            }
            // 获取到的是对应的班级的学生人数 
            this.$post('class_users/search', data).then((res) => {
                this.newData = res.data.result.data
                // console.log('aaaaaaaaaaaa', res.data.result.data)
            })

        },
        // 查看主题讨论评论
        lookStu1(stuId) {
            // console.log(stuId)
            this.showOtherList = false;
            this.showOtherList2 = false;
            this.showOtherList3 = true;
            this.showOtherList4 = false;
            this.evaluate = false
            this.classId = stuId

            var data = {
                class_id: stuId,
                offset: 0,
                length: 999,
                token: this.$store.state.instructor
            }
            // 获取到的是对应的班级的学生人数 
            this.$post('class_users/search', data).then((res) => {
                this.newData = res.data.result.data
                // // console.log(res,'2222222222222222222')
                this.productID = res.data.result.data[0].productID
                // // console.log(this.productID)
            })
            this.$post('class/get_project_by_class_id', {
                id: stuId,
                token: this.$store.state.instructor,
                offset: 0,
                length: 999,
            }).then(res => {
                let project_ids = res.data.result.data[0].project_id
                this.$post('project_tasks/search_group_by_task', {
                    project_id: project_ids,
                    token: this.$store.state.instructor,
                    offset: 0,
                    length: 999
                }).then(res => {
                    // // console.log(res)
                    let project_task = res.data.result.data
                    let resource_idArr = []
                    project_task.map((item, index) => {
                        item.task_activities.map((item1, index1) => {
                            let arr = []
                            arr = JSON.parse(item1.resources)
                            arr.map((item2, index2) => {
                                item2.items.map((item3, index3) => {

                                    if (item3.type == 6) {
                                        resource_idArr.push(item3.resources[0])
                                    }
                                })
                            })
                        })
                    })

                    resource_idArr.map((item, index) => {
                        this.$post('discuss_theme/get_with_comment', {
                            token: this.$store.state.instructor,
                            resource_id: item,
                            offset: 0,
                            length: 999
                        }).then(res => {
                            // console.log(res)
                            this.noticeContent.push(res.data.result)
                        })
                    })
                    // console.log(this.noticeContent)
                    // // console.log(resource_idArr)
                })

            })

        },
        // 主题讨论按钮
        noticeCommend(item) {
            this.noticedialogVisible = true
            this.question_id = item.id
            // console.log(item)
            this.$post('comment/get_comment_by_theme', {
                discuss_theme_id: item.id,

                product_id: this.productID,
                offset: 0,
                length: 999
            }).then(res => {
                this.noticeList = res.data.result.data
            })
        },
        lookStu2(stuId) {
            this.classId = stuId
            // console.log(stuId)
            this.showOtherList = false;
            this.showOtherList2 = false;
            this.showOtherList3 = false;
            this.showOtherList4 = true;
            this.evaluate = false
            var data = {
                class_id: stuId,
                offset: 0,
                length: 999,
                token: this.$store.state.instructor
            }
            // 获取到的是对应的班级的学生人数 
            this.$post('class_users/search', data).then((res) => {

                // console.log('aaaaaaaaaaaa', res.data.result.data[0].product_id)
                this.$post('answ_question/search', {
                    product_id: res.data.result.data[0].product_id,
                    class_id: stuId,
                    offset: 0,
                    length: 999
                }).then(res => {
                    // console.log(res)
                    this.question_answer = res.data.result.data

                })
            })

        },
        lookComments(item) {
            this.commendVisible = true

            this.$post('answ_question_comment/search', {
                answ_question_id: item.id,
                class_id: this.classId,
                offset: 0,
                length: 999
            }).then(res => {
                // console.log(res)
                this.commendList = res.data.result.data
            })

            this.$post('instructor_reply/search', {
                answ_question_id: item.id,
                instructor_id: this.instructor_id1,
                class_id: this.classId,
                length: 999,
                offset: 0,
            }).then(res => {
                // console.log('fudaoyuanpinglun', res)
                this.instructorCommend = res.data.result.data
            })
        },
        // 主题讨论评论的回复
        lookComments1(item) {
            // console.log(item)
            this.notivecommendVisible = true
            this.$post('stu_res_comment/search', {
                comment_id: item.id,
                product_id: this.productID,
                discuss_theme_id: this.question_id,
                offset: 0,
                length: 999

            }).then(res => {
                // console.log(res)
                this.noticeList1 = res.data.result.data
            })
        },
        reply(item) {
            this.replyVisible = true
            this.question_id = item.id
        },
        reply1(item) {
            this.noticereplyVisible = true
            this.question_id = item.id
        },
        replyPost() {
            // // console.log(11111)
            // // console.log(this.instructor_id1)


            this.$post('instructor_reply/insert', {

                answ_question_id: this.question_id,
                instructor_id: this.instructor_id1,
                content: this.replyText,
                class_id: this.classId
            }).then(res => {
                this.replyVisible = false
                this.replyText = ''
                this.$message({
                    type: 'success',
                    message: '提交成功'
                })
            })
        },
        replyPost1() {
            // // console.log(11111)
            // // console.log(this.instructor_id1)

            this.$post('instructor/get', {
                id: this.instructor_id1,
                token: this.$store.state.instructor,
            }).then(res => {
                // // console.log(res)
                let obj = res.data.result
                this.$post('stu_res_comment/insert', {
                    comment_id: this.question_id,
                    instructor_name: obj.name,
                    answ_question_id: this.question_id,
                    user_id: this.instructor_id1,
                    content: this.replyText,
                    class_id: this.classId,
                    type: 1
                }).then(res => {
                    this.noticereplyVisible = false
                    this.replyText = ''
                    this.$message({
                        type: 'success',
                        message: '提交成功'
                    })

                })
            })


        },
        // 评分的按钮
        evaluateBtn(data) {
            // // console.log(data)
            const {
                href
            } = this.$router.resolve({
                path: '/studentsmessage',
                query: {
                    purchasedId: data.purchased_id,
                    userId: data.id,
                    classId: data.class_id,
                    instructor_id: this.instructor_id
                }
            })
            window.open(href, '_blank')
            // this.showOtherList = false;
            // this.showOtherList2 = false;
            // this.evaluate = true;
        },
        // 进入第二层之后的返回 
        listBack() {
            this.showOtherList = true;
            this.showOtherList2 = false;
            this.showOtherList3 = false;
            this.evaluate = false;
        },
        listBack1() {
            this.showOtherList = true;
            this.showOtherList2 = false;
            this.showOtherList3 = false;
            this.showOtherList4 = false;
            this.evaluate = false;
        },
        onSubmit() {
            // console.log('提交的方法被触发了')
        },
        // 返回到之前的页面 
        reset() {
            this.showOtherList = false;
            this.showOtherList2 = true;
            this.evaluate = false;
        },
        // 修改密码表单的方法
        submitForm() {
            if (this.$isAbnormal(this.password) || this.$isAbnormal(this.repassword)) {
                this.$message({
                    type: 'error',
                    message: '请输入数据'
                })
                return
            } else if (this.password !== this.repassword) {
                this.$message({
                    type: 'error',
                    message: '两次密码输入不一致'
                })
                return
            } else {
                this.$post('instructor/setpswd', {
                    id: this.$store.state.instructor,
                    opassword: this.password
                }).then(res => {
                    this.$message({
                        type: 'success',
                        message: '密码修改成功'
                    })
                    this.password = ''
                    this.repassword = ''
                })
            }
        },

        //   重置的方法
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },

        // 实现本地搜索的方法
        search() {
            // this.$post('instructor/filter_student', {
            //     token: this.$store.state.instructor,
            //     shop_id: this.$store.state.store.id,
            //     offset: (this.currentPage - 1) * this.pageSize,
            //     length: this.pageSize,
            //     login_name: this.login_name,
            //     user_name: this.user_name,
            //     idcard: this.idcard,
            //     company: this.company,
            //     class_name: this.class_name
            // }).then(res => {
            //     this.total = res.data.result.total
            //     this.tableData = res.data.result.data
            // })

            this.$post('class_users/filter_student', {
                token: this.$store.state.instructor,
                login_name: this.login_name,
                user_name: this.user_name,
                idcard: this.idcard,
                company: this.company,
                label_name: this.label_name,
                parent_label_name: this.parent_label_name,
                class_id_arr: JSON.stringify(this.class_id_arr),
                offset: (this.currentPage - 1) * this.pageSize,
                length: this.pageSize
            }).then(res => {
                this.total = res.data.result.total
                this.tableData = res.data.result.data
                // // console.log('res',this.tableData)

                this.getAnsweringNum(this.tableData)

                // 重置数据
                this.login_name = ''
                this.user_name = ''
                this.idcard = ''
                this.company = ''
                this.label_name = ''
                this.parent_label_name = ''
            })

        },

        getData() {
            // 获取辅导员下面班级的信息
            this.$post('instructor/get_class', {
                token: this.$store.state.instructor,
                shop_id: 8,
                offset: 0,
                length: 999
            }).then(res => {

                // 班级列表
                let list = res.data.result.data

                // 获取辅导员管理的班级id列表
                let class_id_arr = []
                list.map(item => {
                    class_id_arr.push(item.class_id)
                })
                this.class_id_arr = class_id_arr
                // 获取辅导员的发布公告数量
                this.getBulletinNum()

                // 搜索学员列表
                this.search()

                // 学生总人数
                let studentNum = 0
                // 已学完学生人数
                let goodStudentNum = 0
                // 未学完学生人数
                let badStudnetNum = 0
                for (let i = 0; i < list.length; i++) {

                    studentNum = studentNum + list[i].class_users.length
                    for (let j = 0; j < list[i].class_users.length; j++) {
                        let obj = list[i].class_users[j]

                        // 已学完的学生人数
                        if (obj.progress * 1 == 1) {
                            goodStudentNum++
                        } else if (obj.progress * 1 < 1) { // 未完成学习的学生人数
                            badStudnetNum++
                        }
                    }
                }
                this.studentNum = studentNum
                this.goodStudentNum = goodStudentNum
                this.badStudnetNum = badStudnetNum

                // 计算班级评分百分比
                // console.log(list)
                this.percentageCalculation(list)
            })
        },
        // getNumstu() {
        //     let data = {
        //         offset: (this.currentPage - 1) * this.pageSize,
        //         length: this.pageSize,
        //         token: this.$store.state.instructor
        //     }
        //     this.$post('class_users/filter_student', data).then((res) => {
        //         this.total = res.data.result.data.length
        //         this.tableData = res.data.result.data
        //         // for (let i = 0; i < this.tableData.length; i++) {
        //         //     this.tableData[i].rate = JSON.parse(this.tableData[i].rate)
        //         // }
        //         // console.log('学员列表的数据。。。。', this.tableData)
        //         // this.tableData = this.tableData.filter(item => item.class_name != null)
        //         this.tableDataNum = res.data.result.data
        //     })
        // },

        // 计算班级评分百分比
        percentageCalculation(list) {
            let percentageArray = []
            for (let i = 0; i < list.length; i++) {
                let obj = {}
                let num = 0 // 有分数的学生个数
                obj.class_id = list[i].class_id
                obj.class_name = list[i].class_name
                for (let j = 0; j < list[i].class_users.length; j++) {
                    obj.product_name = list[i].class_users[0].product_name
                    obj.length = list[i].class_users.length
                    if (list[i].class_users[j].score != null) {
                        num++
                    }
                }
                obj.num = num
                if (!this.$isAbnormal(obj.class_id) && !this.$isAbnormal(obj.class_name)) {
                    percentageArray.push(obj)
                }
            }
            this.percentageArray = percentageArray
            // console.log(this.percentageArray)
        },

        // 评价情况
        getEvaluationStatus(data) {
            let str = ''
            if (data == null) {
                return '未开始'
            }
            let item = JSON.parse(data)
            debugger
            // console.log('进来了')
            // console.log('item', item)
            this.length = 0
            this.num = 0
            for (let i = 0; i < item.length; i++) {

                for (let j = 0; j < item[i].task_activities.length; j++) {

                    for (let k = 0; k < item[i].task_activities[j].resources.length; k++) {

                        for (let x = 0; x < item[i].task_activities[j].resources[k].items.length; x++) {

                            let obj = item[i].task_activities[j].resources[k].items[x]
                            let a = this.$isAbnormal(obj.type)
                            if (!this.$isAbnormal(obj.type)) {
                                if (obj.type == 7 || obj.type == 6) {
                                    this.length += 1
                                    if (!this.$isAbnormal(obj.instructorComment)) {
                                        this.num += 1
                                    }
                                }
                            }
                        }

                        if (this.length != 0 && this.num != 0) {
                            if (this.length == this.num) {
                                str = '已完成'
                            }
                        } else if (this.num > 0) {
                            str = '已评价'
                        } else {
                            str = '未开始'
                        }
                    }
                }
            }
            return str

        },

        handleSizeChange(pageSize) {
            this.pageSize = pageSize
            this.getNumstu()
        },

        handleCurrentChange(currentPage) {
            this.currentPage = currentPage
            this.getNumstu()
        },

        // 获取辅导员主题讨论发帖数
        getDiscussNum() {
            this.$post('stu_res_comment/get_num', {
                token: this.$store.state.instructor,
                instructor_id: this.instructor_id,
                type: 1,
                offset: 0,
                length: 9999
            }).then(res => {
                this.discussNum = res.data.result.total
            })
        },

        // 获取辅导员发布公告简报数量
        getBulletinNum() {
            this.$post('class_bulletin/get_num', {
                token: this.$store.state.instructor,
                class_id_arr: JSON.stringify(this.class_id_arr),
                offset: 0,
                length: 9999
            }).then(res => {
                this.bulletinNum = res.data.result.total
            })
        },

        // 获取辅导员答疑数
        getAnsweringNum(list) {
            let answeringNum = 0
            for (let i = 0; i < list.length; i++) {

                if (list[i].rate) {
                    let rate = JSON.parse(list[i].rate)

                    for (let j = 0; j < rate.length; j++) {

                        for (let k = 0; k < rate[j].task_activities.length; k++) {

                            for (let x = 0; x < rate[j].task_activities[k].resources.length; x++) {

                                for (let y = 0; y < rate[j].task_activities[k].resources[x].items.length; y++) {

                                    let item = rate[j].task_activities[k].resources[x].items[y]
                                    if (item.instructorComment) {
                                        answeringNum++
                                    }
                                }
                            }
                        }
                    }
                }
            }
            this.answeringNum = answeringNum
        },

        // 班级公告上传限制
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || 'image/png';
            const isLt500K = file.size / 1024 / 1024 < 0.5;

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt500K) {
                this.$message.error('上传头像图片大小不能超过 500K!');
            }
            return isJPG && isLt500K;
        },

        // 显示学生列表
        showStudentList(item) {
            this.dialogStudentsVisible = true
            this.currClassId = item.class_id

            this.getStudentList()
        },

        // 发送请求获取学生列表
        getStudentList() {
            this.$post('class_users/find_students', {
                token: this.$store.state.instructor,
                class_id: this.currClassId,
                offset: (this.studentCurrPage - 1) * 10,
                length: 10
            }).then(res => {
                this.studentList = res.data.result.data
                this.studentTotal = res.data.result.total
            })
        },

        // 当选择项发生变化时触发该方法
        // 给学员列表赋值
        handleSelectionChange(selection) {
            let list = []
            if (selection.length > 0) {
                selection.map(item => {
                    list.push(item.user_id)
                })
            }
            this.idArr = list
        },

        // 显示发送站内信
        showSend() {
            // 如果没有选择学员，则不让发送站内信
            if (this.idArr.length <= 0) {
                return this.$message({
                    type: 'error',
                    message: '请最少选择一名学员'
                })
            }

            this.dialogMessageVisible = true
        },

        // 发送站内信
        send() {
            let message = this.message
            if (this.$isAbnormal(message)) {
                return this.$message({
                    type: 'error',
                    message: '请输入内容'
                })
            }

            let flag = false
            for (let i = 0; i < this.idArr.length; i++) {
                // 创建站内信
                this.$post('message/create', {
                    token: this.$store.state.instructor,
                    user_id: this.idArr[i],
                    instructor_id: this.instructor_id1,
                    content: message,
                    status: 0
                })
            }

            this.$message({
                type: 'success',
                message: '发送成功'
            })

            this.dialogMessageVisible = false
        },

        // 学生列表的当前页发生变化时调用该方法
        handleCurrentChangeByStudents(currPage) {
            this.studentCurrPage = currPage
            this.getStudentList()
        }

    },
    mounted() {
        // 开始进来获取到辅导员下的全部信息 
        this.getData()

        // 搜索学员列表
        // this.search()

        // 获取辅导员主题讨论发帖数
        this.getDiscussNum()
        // 获取辅导员发布公告简报数量
        this.getBulletinNum()
    }
}
